// extracted by mini-css-extract-plugin
module.exports = {"wi7qe6i":"wi7qe6i"};